import { useYodlStore } from '@frontend/client/contexts/useYodlStore';
import { TokenValue } from '@frontend/types';

export type TokenInResponse = {
  amount?: TokenValue | undefined;
  error?: null | string;
  isLoading: boolean;
};

/**
 *
 * Add some minor margin to account for DEX swap/rounding errors.
 * 1% should enough
 *
 * @param value
 * @returns
 */
export function addAllowanceMargin(value: bigint) {
  return (value * 101n) / 100n;
}

export const usePaymentChainId = () => {
  const tokenIn = useYodlStore((state) => state.tokenIn);

  return tokenIn?.token?.chainId;
};

export const useAllowanceToken = () => {
  const tokenIn = useYodlStore((state) => state.tokenIn);
  const tokenInAmount = useYodlStore((state) => state.tokenInAmount);

  const defaultResponse = {
    token: tokenIn?.token,
    amount: undefined,
  };

  if (!tokenIn?.token) {
    return {
      ...defaultResponse,
      token: undefined,
    };
  }

  if (tokenIn.variant === 'transfer') {
    return {
      ...defaultResponse,
      amount: tokenInAmount?.amount,
    };
  }

  if (!tokenInAmount.amount) {
    return defaultResponse;
  }

  const allowValue = addAllowanceMargin(tokenInAmount.amount.value);
  return {
    ...defaultResponse,
    amount: {
      ...tokenInAmount.amount,
      value: allowValue,
    },
  };
};
